import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component'
import { environment } from 'src/environments/environment'
import { WbsService } from 'src/app/services/wbs.service'
import { FrontEndParams } from '@interserve/igx-angular'
import { IsAccountService } from '@interserve/angular'

@Component({
    selector: 'app-select-area',
    templateUrl: './select-area.component.html',
    styleUrls: ['./select-area.component.scss'],
})
export class SelectAreaComponent implements OnInit {
    @ViewChild('snackbar', { static: true }) private snackbar!: SnackbarComponent

    public frontendCd = 'selectAreaV3'
    public title = 'ドキュメント 管理／エリア選択'

    environmentKey = environment.environmentKey

    public loading = false
    public customerId = ''

    //WBSライブラリ用
    public frontEndParams!: FrontEndParams

    constructor(private wbsService: WbsService, private isAccountService: IsAccountService, private router: Router) {}

    ngOnInit() {
        this.customerId = this.isAccountService.account?.customerId ?? ''

        this.initialize()
    }
    async initialize() {
        this.loading = true
        try {
            //フロントエンド設定をWBSに渡す
            let param = { customerId: this.customerId }
            this.frontEndParams = this.wbsService.setFrontendParams(this.frontendCd, param)

            this.loading = false
        } catch (error) {
            this.snackbar.error('画面の初期化が失敗しました')
            this.loading = false
        }
    }
    actions = {
        showCassette: (event: any) => {
            this.router.navigate([`/wbs-viewer/${event.id}/1`]) //0:閲覧のみ、1:追加可
        },
        updateCassette: (event: any) => {
            this.router.navigate(['/create-cassette'], { queryParams: { id: event.id } })
        },
        showUploadItem: (event: any) => {
            ;-this.router.navigate([`/select-wbs-item/${event.id}`]) //0:閲覧のみ、1:追加可
        },
    }
}
